import { render, staticRenderFns } from "./LetterShow.vue?vue&type=template&id=57dc441c&scoped=true&"
import script from "./LetterShow.vue?vue&type=script&lang=js&"
export * from "./LetterShow.vue?vue&type=script&lang=js&"
import style0 from "./LetterShow.vue?vue&type=style&index=0&id=57dc441c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57dc441c",
  null
  
)

export default component.exports